import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/serviceMesh/icn_DigitalServiceMesh-01.png';
import icn_02 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-02.png';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cloudP_03.png';
import icn_04 from '../../assets/img/landingPage/composable/icn_composable_03.png';
import icn_05 from '../../assets/img/landingPage//serviceMesh/icn_DigitalServiceMesh-05.png';
import icn_06 from '../../assets/img/landingPage//serviceMesh/icn_DigitalServiceMesh-06.png';

//key features
import key01 from '../../assets/img/landingPage/ilustracion-home_v4.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const DigitalServiceMesh = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Telecom & infrastructure',
            text: "Orchestrate services across geographies and providers in a secure mesh.",
            altDescription: "Orchestrate services across geographies and providers in a secure mesh.",
            image: key01,
        },
        Key_Feature_02: {
            title: "Banking & Finance",
            text: "Monetize APIs and connect legacy cores to mobile and fintech services.",
            altDescription: "Monetize APIs and connect legacy cores to mobile and fintech services.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'SaaS Platforms',
            text: 
            "Expose internal services as public APIs, fully governed and monetized",
            altDescription: 'Expose internal services as public APIs, fully governed and monetized',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'Digital Government',
            text: 
            "Connect citizens, data, and services through secure, observable infrastructure.",
            altDescription: 'Connect citizens, data, and services through secure, observable infrastructure',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: 'Retail & Logistics',
            text: 
            "Build ecosystems of suppliers, logistics, and partners through API gateways.",
            altDescription: 'Build ecosystems of suppliers, logistics, and partners through API gateways.',
            image: product_gateway,
        },
        Key_Feature_06: {
            title: 'Technology providers',
            text: 
            "Deliver composable services through multi-tenant API environments.",
            altDescription: 'Deliver composable services through multi-tenant API environments.',
            image: product_gateway,
        },
    }

//Key Benefits Bento
    const items2 = [
            {
              icon: icn_01,
              title: 'Telecom & infrastructure',
              paragraphs: [
                'Orchestrate services across geographies and providers in a secure mesh.',
              ],
            
            },
            {
              icon: icn_02,
              title: 'Banking & Finance',
              paragraphs: [
                'Monetize APIs and connect legacy cores to mobile and fintech services.',
              ]
            },
    
            {
              icon: icn_03,
              title: 'SaaS Platforms',
              paragraphs: [
                'Expose internal services as public APIs, fully governed and monetized.',
              ]
            },
            {
              icon: icn_04,
              title: 'Digital Government',
              paragraphs: [
                'Connect citizens, data, and services through secure, observable infrastructure.',
              ]
            },
            {
              icon: icn_05,
              title: 'Retail & Logistics',
              paragraphs: [
                'Build ecosystems of suppliers, logistics, and partners through API gateways.',
              ]
            },
             {
              icon: icn_06,
              title: 'Technology providers',
              paragraphs: [
                'Deliver composable services through multi-tenant API environments.',
              ]
            },
          ];
          
         const breakpointColumnsObj = {
            default: 3, //Cambio de columnas verticales
            1100: 2,
            700: 1
          
        };


    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Eliminate operational silos and inefficiencies',
          paragraphs: [
            'Simulate and deploy APIs without affecting production systems.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'Reduce manual workloads and accelerate throughput',
          paragraphs: [
            'Use Gen-AI to automate logic, reduce redundancies, and speed up service delivery',
          ]
        },

        {
          icon: icn_03,
          title: 'Improve accuracy, agility, and real-time visibility',
          paragraphs: [
            'Monitor and track every interaction.',
          ]
        },
        {
          icon: icn_04,
          title: 'Free up teams to focus on innovation and value creation',
          paragraphs: [
            'Empower more teams to participate in digital transformation.'
          ]
        },
      ];
      
    const breakpointColumnsObj2 = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0 fl-txt-container-s">Digital Service Mesh & API Economy 2.0</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">From endpoints to ecosystems. Power the API Economy 2.0 with AVAP.</p>
                                {/*<p className="fl-text fl-txt-container-s" >
                                With AVAP Framework, government agencies and public institutions can modernize their systems, unify data, and expose services securely,  all through modular, reusable APIs. Unlock real-time visibility, accelerate project delivery, and simplify compliance with an API-first approach built for scale and trust.
                                </p>*/}
                                {/*Boton Contact Us*/}  
                                {/*<a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>*/}
              </section>

        

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-0"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}
                
                    <h2 className='fl-subtitle pt-8'>Turn Your Architecture Into a Dynamic Service Economy</h2>
                        <p className="fl-text fl-txt-container-s" >
                        APIs have evolved from technical interfaces into strategic business assets. AVAP Framework empowers organizations to build and manage a Digital Service Mesh while fully embracing the API Economy 2.0 where APIs are enriched with AI, contextual data, and monetization capabilities.
                        </p>
                        <p className="fl-text fl-txt-container-s" >
                        With AVAP, modernize your integration strategy, gain end-to-end visibility and control, and unlock new revenue streams through seamless orchestration.
                        </p>
                    {/*Boton Contact Us*/}  
                        <a className="glowBtn-dark pb-5" style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
    
                 {/*<section className='container'>   
                 <div className="fl-card-border container text-center">
                    <h2 className="fl-title mt-0 py-2 gradient-text fl-title m-4">What is Hyperautomation?</h2>

                    <p className="fl-text fl-txt-container-s">“A disciplined, business-driven approach used by organizations to rapidly identify, vet, and automate as many business and IT processes as possible.”
                    </p>
                    <p className="fl-text fl-txt-container-s bold">- Gartner -</p>
                    <br/>
                    <p className="fl-subtitle">It combines:<p/> 
        
                    <ul className="fl-text fl-txt-container-s">
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> RPA:</strong> Task-level automation.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> AI/ML:</strong> Cognitive capabilities and smart decisions.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> BPM:</strong> Business process modeling and orchestration.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> iPaaS:</strong> Seamless integration across platforms.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> APIs & microservices:</strong> Agile service composition.</li> 
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Low-code/no-code tools:</strong> Democratized automation development.</li> 
                        </ul>
                        </p>
                    
                    MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO
                <div className="container pt-8">
                <div className="fl-title text-center mb-5 gradient-text">
                Why It Matters
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <p className="p">{item.title}</p>
                        </div>
                    ))}
                    </Masonry>
                </div>
                </div>
                </section>*/}

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container pt-6">
                    <div className="fl-title text-center mb-5">
                    Key Use Cases
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item, idx) => (
                        <div key={idx} className="grayBox fl-card text-center">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/*Boton Contact Us*/}  
                {/* <a className="glowBtn-dark mb-4 " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>*/}

                   {/* <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction. Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>*/}

                </section>

                

                {/* Sección Key Features */}
                {/*<div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                           
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0 fl-txt-container-s">Key Use Cases</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>*/}


                <div className="fl-card-border container text-center">
                    <h2 style={{ marginTop: '40px' }} className="fl-txt-container-s fl-subtitle mt-0 py-5 gradient-text fl-title m-4">AVAP: Your Gateway to the Future of Integration</h2>
                    <p>AVAP Framework empowers your transition from API infrastructure to a next-gen platform built on intelligent, monetizable, and interoperable services.
                    Whether you’re modernizing or building a new ecosystem from scratch—AVAP brings the tools, architecture, and intelligence to lead the way.
                    </p>
                {/*Boton Contact Us*/}  
                     <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                </div>

                {/* Sección Built */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Built for modern teams</h3>
                                    <p>AVAP Integration empowers both IT and business users with no-code/low-code tools and reusable virtual connectors for:
                                    </p>*/} 
                                    {/* Sección Bullets */}
                                   {/* <ul className="fl-bullets fl-text  .fl-txt-container-s " >
                                    <li className="fl-bullets">Cloud & SaaS platforms</li>
                                    <li className="fl-bullets">On-prem legacy systems</li>
                                    <li className="fl-bullets">Databases & messaging systems</li>
                                    <li className="fl-bullets">Internal and third-party APIs</li>
                                    </ul>
                                    <p>Break data silos and give teams the freedom to build connected workflows across any system.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

                
                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unify your data
                                </p>
                                <p className="fl-text">
                                Create a single source of truth by linking all your systems, regardless of format or source.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Accelerate delivery
                                </p>
                                <p className="fl-text">
                                Start faster with AI-assisted configuration, smart templates, and reusable integration assets.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Make integration intelligent
                                </p>
                                <p className="fl-text">
                                Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Protect every connection
                                </p>
                                <p className="fl-text">
                                Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.

                                </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Measure and improve
                                </p>
                                <p className="fl-text">
                                Track integration KPIs in real time with built-in analytics and smart dashboards.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/} 

                


                {/* Sección built for secure */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Designed for your architecture</h3>
                                    <p>Whether you're operating in the cloud, on-prem, or in hybrid environments, AVAP Framework adapts seamlessly to your infrastructure and governance model.

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default DigitalServiceMesh;
